/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibSimpleFunctionRegistryRichErrors1,
  LibSimpleFunctionRegistryRichErrors1Interface,
} from "../LibSimpleFunctionRegistryRichErrors1";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "targetImpl",
        type: "address",
      },
    ],
    name: "NotInRollbackHistoryError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibSimpleFunctionRegistryRichErrors1__factory {
  static readonly abi = _abi;
  static createInterface(): LibSimpleFunctionRegistryRichErrors1Interface {
    return new utils.Interface(
      _abi
    ) as LibSimpleFunctionRegistryRichErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibSimpleFunctionRegistryRichErrors1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibSimpleFunctionRegistryRichErrors1;
  }
}
